import { useEffect, useMemo, useState } from 'react';
import Swal from 'sweetalert2';

import usePanelEdicion, { confirmarDescartar } from './usePanelEdicion';

const normalizar = texto => String(texto ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();

// Lista con buscador y un panel lateral ('agregar' / 'editar') para las vistas sin vista previa del sitio.
// `vacio` debe ser una constante del módulo: es el borrador inicial y la base para comparar cambios
const useListaAdmin = ({ obtener, obtenerUso, vacio, camposBusqueda, ordenar }) => {
    const [todos, setTodos] = useState(null);
    const [uso, setUso] = useState({});
    const [busqueda, setBusqueda] = useState('');
    const [editar, setEditar] = useState(null);
    const [borrador, setBorrador] = useState(vacio);
    const [version, setVersion] = useState(0);

    useEffect(() => {
        cargar();
    }, []);

    const cargar = async () => {
        const [res, resUso] = await Promise.all([obtener(), obtenerUso?.()]);
        if (res.success) {
            setTodos(ordenar ? [...(res.data ?? [])].sort(ordenar) : res.data ?? []);
        } else {
            Swal.fire('Error!', 'No se pudo obtener la lista, codigo: ' + res.code, 'error');
        }
        if (resUso?.success) setUso(resUso.data ?? {});
    }

    // El original se arma igual que el borrador, para que los campos que no trae el registro no cuenten como cambio
    const original = useMemo(() => (editar ? { ...vacio, ...editar } : vacio), [editar, vacio]);
    const hayCambios = JSON.stringify(borrador) !== JSON.stringify(original);

    const limpiar = () => {
        setEditar(null);
        setBorrador(vacio);
        setVersion(version => version + 1);
    }

    const panel = usePanelEdicion({ hayCambios, onCerrar: limpiar });

    // Devuelve si se abrió (false si ya estaba abierto o si no se quisieron descartar los cambios)
    const abrir = async (nombre, registro = null) => {
        if (panel.abierto === nombre && editar?._id === registro?._id) return false;
        if (hayCambios && !(await confirmarDescartar())) return false;
        setEditar(registro);
        setBorrador(registro ? { ...vacio, ...registro } : vacio);
        setVersion(version => version + 1);
        panel.abrir(nombre);
        return true;
    }

    const lista = useMemo(() => {
        if (!todos) return null;
        const termino = normalizar(busqueda);
        if (!termino) return todos;
        return todos.filter(registro => camposBusqueda.some(campo => normalizar(registro[campo]).includes(termino)));
    }, [todos, busqueda, camposBusqueda]);

    return {
        todos,
        lista,
        cargando: !todos,
        uso,
        busqueda,
        setBusqueda,
        editar,
        borrador,
        cambiar: cambios => setBorrador(borrador => ({ ...borrador, ...cambios })),
        hayCambios,
        version,
        panel,
        abrirAgregar: () => abrir('agregar'),
        abrirEditar: registro => abrir('editar', registro)
    };
};

export default useListaAdmin;
